import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Tooltip } from "@mui/material";
import { LockStatus } from "@shared/types/domain";

const LOCK_TITLES: Record<LockStatus, string> = {
  impossible: "Not all PIDs are approved yet",
  locked: "All PIDs locked",
  partial: "Some PIDs locked",
  open: "All PIDs unlocked",
};

const LOCK_COLORS: Record<LockStatus, string> = {
  impossible: "#C4CDD8",
  locked: "#E30613",
  partial: "#FF9800",
  open: "#43A047",
};

export function LockStatusIcon({ lockStatus }: { lockStatus: LockStatus }) {
  return (
    <Tooltip title={LOCK_TITLES[lockStatus]}>
      <Box
        component="span"
        sx={{
          ml: 0.5,
          display: "inline-flex",
          alignItems: "center",
          color: LOCK_COLORS[lockStatus],
        }}
      >
        {lockStatus === "locked" ? (
          <LockIcon sx={{ fontSize: 14 }} />
        ) : lockStatus === "impossible" ? (
          <LockOutlinedIcon sx={{ fontSize: 14 }} />
        ) : (
          <LockOpenIcon sx={{ fontSize: 14 }} />
        )}
      </Box>
    </Tooltip>
  );
}
